module.exports = __webpack_public_path__ + "img/1440.01c52089.jpg";